"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Reports/components/DaysChart.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);


var _Tooltip = require('web/components/Tooltip');

// A short range keeps its bars this narrow, centred.
const MIN_SLOTS = 7
// Each bar shows its total above it while the bars are wide enough: up to a
// month of days (RP-3).
const MAX_LABELLED_DAYS = 31

const dayLabel = (day) => _moment2.default.call(void 0, day, _moment2.default.HTML5_FMT.DATE).format('MMM D')
const weekdayLabel = (day) => _moment2.default.call(void 0, day, _moment2.default.HTML5_FMT.DATE).format('ddd, MMM D')
const percent = (n, max) => `${n / max * 100}%`





/* Texts per day as stacked bars: delivered at the bottom, the rest on top.
 * Hovering or focusing a day shows its date and counts (RP-3). */
const DaysChart = ({ days }) => {
  const max = Math.max(1, ...days.map(d => d.Texts))
  const first = days[0]
  const last = days[days.length - 1]
  const slots = Math.max(days.length, MIN_SLOTS)
  const offset = (slots - days.length) / 2
  // The axis labels sit under the first and last bars.
  const axisInset = `${offset / slots * 100}%`
  const isLabelled = days.length <= MAX_LABELLED_DAYS

  return (
    _react2.default.createElement('figure', { className: "settings--org-reports--chart", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
      , _react2.default.createElement('figcaption', { className: "settings--org-reports--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Texts per day"  )
      , _react2.default.createElement('div', {
        role: "group",
        'aria-label': "Texts per day"  ,
        className: "settings--org-reports--chart-bars",
        style: { paddingLeft: axisInset, paddingRight: axisInset }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}

        ,  days.map(d => {
          const notDelivered = d.Texts - d.Delivered
          const label = `${dayLabel(d.Day)}: ${d.Texts} texts, ${d.Delivered} delivered, ${notDelivered} not delivered`
          return (
            _react2.default.createElement(_Tooltip.HoverTooltip, {
              key: d.Day,
              type: "dark",
              place: "top",
              showOnFocus: true,
              className: "settings--org-reports--day",
              content: (
                _react2.default.createElement('span', { className: "settings--org-reports--day-tip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
                  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 54}},  weekdayLabel(d.Day) )
                  , _react2.default.createElement('span', { className: "settings--org-reports--legend-item settings--org-reports--legend-delivered" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Delivered " ,  d.Delivered )
                  , _react2.default.createElement('span', { className: "settings--org-reports--legend-item settings--org-reports--legend-not-delivered" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "Not delivered "  ,  notDelivered )
                  , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}},  d.Texts , " " ,  d.Texts === 1 ? 'text' : 'texts' )
                )
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

              , _react2.default.createElement('div', { className: "settings--org-reports--day-bar", role: "img", 'aria-label': label, tabIndex: 0, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
                /* The day's stack, its total riding on top. */
                , _react2.default.createElement('div', { className: "settings--org-reports--day-stack", style: { height: percent(d.Texts, max) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
                  ,  isLabelled && d.Texts > 0 && _react2.default.createElement('span', { className: "settings--org-reports--day-value", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}},  d.Texts ) 
                  , _react2.default.createElement('div', { className: "settings--org-reports--bar-not-delivered", style: { height: percent(notDelivered, Math.max(1, d.Texts)) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
                  , _react2.default.createElement('div', { className: "settings--org-reports--bar-delivered", style: { height: percent(d.Delivered, Math.max(1, d.Texts)) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
                )
              )
            )
          )
        })
      )
      ,  first && last && (
        _react2.default.createElement('div', {
          className: "settings--org-reports--chart-axis",
          style: { paddingLeft: axisInset, paddingRight: axisInset, justifyContent: days.length > 1 ? undefined : 'center' },
          'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}

          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 79}},  dayLabel(first.Day) )
          ,  days.length > 1 && _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  dayLabel(last.Day) ) 
        )
      )
      , _react2.default.createElement('div', { className: "settings--org-reports--legend", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
        , _react2.default.createElement('span', { className: "settings--org-reports--legend-item settings--org-reports--legend-delivered" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "Delivered")
        , _react2.default.createElement('span', { className: "settings--org-reports--legend-item settings--org-reports--legend-not-delivered" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Not delivered" )
      )
    )
  )
}

exports. default = DaysChart
